import { MessageCircle, Instagram, MapPin, Clock } from "lucide-react";
import { LogoFull } from "./Logo";
import { scrollToSection } from "@/lib/scroll";
import { waLink, WHATSAPP_DISPLAY, INSTAGRAM_URL, ADDRESS, HOURS } from "@/lib/constants";

const NAV = [
  { label: "Início", hash: "#inicio", testid: "footer-nav-inicio" },
  { label: "Serviços", hash: "#servicos", testid: "footer-nav-servicos" },
  { label: "Sobre Nós", hash: "#sobre", testid: "footer-nav-sobre" },
  { label: "Contato", hash: "#contato", testid: "footer-nav-contato" },
];

export const Footer = () => (
  <footer className="bg-ink">
    <div className="h-1 bg-gradient-to-r from-signal via-volt to-signal" />

    <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto py-16 grid grid-cols-1 md:grid-cols-3 gap-12">
      <div>
        <div data-testid="footer-logo">
          <LogoFull testid="footer-logo-mark" scale={1.35} />
        </div>
        <p className="mt-5 text-sm italic text-gray-400">"Seu carro em boas mãos."</p>
      </div>

      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt mb-6">Contato</p>
        <ul className="space-y-4 text-sm text-gray-300">
          <li>
            <a
              data-testid="footer-whatsapp-link"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 hover:text-signal transition-colors"
            >
              <MessageCircle className="h-4 w-4 text-signal shrink-0" />
              WhatsApp {WHATSAPP_DISPLAY}
            </a>
          </li>
          <li>
            <a
              data-testid="instagram-link"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 hover:text-signal transition-colors"
            >
              <Instagram className="h-4 w-4 text-signal shrink-0" />
              @mw_autocenter
            </a>
          </li>
          <li data-testid="footer-address" className="flex items-start gap-3">
            <MapPin className="h-4 w-4 text-signal shrink-0 mt-0.5" />
            {ADDRESS}
          </li>
          <li data-testid="footer-hours" className="flex items-start gap-3">
            <Clock className="h-4 w-4 text-signal shrink-0 mt-0.5" />
            <span>
              {HOURS.map((h) => (
                <span key={h} className="block">{h}</span>
              ))}
            </span>
          </li>
        </ul>
      </div>

      <div>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-volt mb-6">Navegação</p>
        <ul className="space-y-3 text-sm">
          {NAV.map((n) => (
            <li key={n.hash}>
              <button
                data-testid={n.testid}
                onClick={() => scrollToSection(n.hash)}
                className="text-gray-300 hover:text-signal transition-colors"
              >
                {n.label}
              </button>
            </li>
          ))}
          <li>
            <a
              data-testid="footer-nav-whatsapp"
              href={waLink()}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-signal transition-colors"
            >
              WhatsApp
            </a>
          </li>
          <li>
            <a
              data-testid="footer-nav-instagram"
              href={INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-300 hover:text-signal transition-colors"
            >
              Instagram
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div className="border-t border-white/[0.08]">
      <div className="px-4 sm:px-6 lg:px-10 max-w-[1400px] mx-auto py-5 flex flex-col sm:flex-row items-center justify-between gap-2">
        <p className="font-mono text-[10px] uppercase tracking-widest text-gray-600">
          © {new Date().getFullYear()} MW Auto Center — Balneário Camboriú · SC
        </p>
        <p className="font-mono text-[10px] uppercase tracking-widest text-gray-600">
          Oficina Mecânica · Centro
        </p>
      </div>
    </div>
  </footer>
);
